module.exports = __webpack_public_path__ + "img/biohazard.4aefebf7.svg";